export const DELETE_PROCESS_STATEMENT_COMMENT_FAILURE = 'DELETE_PROCESS_STATEMENT_COMMENT_FAILURE';

export const deleteProcessStatementCommentFailure = error => ({
    type: DELETE_PROCESS_STATEMENT_COMMENT_FAILURE,
    payload: error,
    error: true,
});
